import type { DashboardWidgetRegistry } from "../DashboardWidgetRenderer";
import CFOInsightsDailyBrief from "../alternative-components/CFOCopilot/CFOInsightsDailyBrief";
import LiquidityInfoCard from "../alternative-components/CFOCopilot/LiquidityInfoCard";
import AttentionInfoCard from "../alternative-components/CFOCopilot/AttentionInfoCard";
import OpportunityInfoCard from "../alternative-components/CFOCopilot/OpportunityInfoCard";
import SpendByCategoryChart from "../alternative-components/CFOCopilot/SpendByCategoryChart";
import CustomeChart from "../alternative-components/CFOCopilot/CustomeComposedChart";
import CfoLineBar from "../alternative-components/CFOCopilot/CfoLineBar";

export const INSIGHTS_WIDGET_REGISTRY: DashboardWidgetRegistry = {
  208: CFOInsightsDailyBrief, // CFO Insights Daily Brief
  209: LiquidityInfoCard, // Liquidity
  210: AttentionInfoCard, // Attention
  211: OpportunityInfoCard, // Opportunity
  212: SpendByCategoryChart, // Spend By Category
  213: CustomeChart, // Inflow vs Outflow
  214: CfoLineBar, // Top Beneficiaries
};
